import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useProdutosContext } from '../context/produtos_context'
import { single_produtos_url as url } from '../utils/constants'
import { formatPrice } from '../utils/helpers'
import {
  Loading,
  Error,
  ProdutosImages,
  AddToCart,
  Stars,
  PageHero,
} from '../components'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const SingleProdutosPage = () => {
  const { id } = useParams()
  const history = useHistory()
  const {
    single_produtos_loading: loading,
    single_produtos_error: error,
    single_produtos: produtos,
    fetchSingleProdutos,
  } = useProdutosContext()

  useEffect(() => {
    fetchSingleProdutos(`${url}${id}`)
  }, [id])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        history.push('/')
      }, 3000)
    }
  }, [error])

  if (loading) {
    return <Loading />
  }
  if (error) {
    return <Error />
  }
  const {
    name,
    description,
    stock,
    stars,
    reviews,
    id: sku,
    company,
    images,
  } =produtos
  return (
    <Wrapper>
      <PageHero title={name} produtos/>
      <div className='section section-center page'>
        <Link to='/produtos' className='btn'>
        volte para produtos
        </Link>
        <div className=' produtos-center'>
          <ProdutosImages images={images} />
          <section className='content'>
            <h2>{name}</h2>
            <Stars stars={stars} reviews={reviews} />
            <p className='desc'> {description}</p>
            <p className='info'>
              <span>Available : </span>
              {stock > 0 ? 'In stock' : 'out of stock'}
            </p>
            <p className='info'>
              <span>SKU : </span>
              {sku}
            </p>
            <p className='info'>
              <span>Brand : </span>
              {company}
            </p>
            <hr />
            {stock > 0 && <AddToCart produtos={produtos} />}
          </section>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.main`
  .produtos-center {
    display: grid;
    gap: 4rem;
    margin-top: 2rem;
  }
  .desc {
    line-height: 2;
    max-width: 45em;
  }
  .info {
    text-transform: capitalize;
    width: 300px;
    display: grid;
    grid-template-columns: 125px 1fr;
    span {
      font-weight: 700;
    }
  }

  @media (min-width: 992px) {
    .produtos-center {
      grid-template-columns: 1fr 1fr;
      align-items: center;
    }
  }
`

export default SingleProdutosPage
